import { AxiosInstance } from 'axios';

import { RedirectResponse } from '../../../../../../../typings/api/integrations/xsite/rest/v1/.common';
import * as types from '../../../../../../../typings/api/integrations/xsite/rest/v1/authentication';

export class AuthenticationServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/oauth-2';

  constructor(private axios: AxiosInstance) {}

  async getXsiteSignOnUrl(params: types.GetXsiteSignOnUrlParameters): Promise<RedirectResponse> {
    return (await this.axios.get(`${this.endpoint}/sign-on`, { params: params.query })).data;
  }

  onXsiteSignOnSuccess(params: types.OnXsiteSignOnSuccessParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
